import React from "react";
import { services, servicesHero } from "../mock/mock";
import Seo from "../seo/Seo";
import { PAGE_SEO } from "../seo/siteConfig";
import { breadcrumbSchema, webPageSchema, serviceSchema } from "../seo/schema";
import ServiceCard from "../components/sections/ServiceCard";
import Reveal from "../components/common/Reveal";
import CircleArrowLink from "../components/common/CircleArrowLink";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import LocationCTA from "../components/sections/LocationCTA";

const Services = () => {
  return (
    <>
      <Seo
        title={PAGE_SEO["/services"].title}
        description={PAGE_SEO["/services"].description}
        path="/services"
        schema={[
          webPageSchema({ ...PAGE_SEO["/services"], path: "/services" }),
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Services", path: "/services" },
          ]),
          ...services.map((s) => serviceSchema(s)),
        ]}
      />
      {/* Hero */}
      <section className="relative min-h-[68vh] flex items-center overflow-hidden">
        <img
          src={servicesHero.bg}
          alt="Device repair services"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/25" />
        <div className="tnf-container relative pt-32 pb-20">
          <Reveal className="max-w-3xl">
            <span className="tnf-eyebrow text-[var(--tnf-orange)]">All Services</span>
            <h1 className="font-display text-white font-extrabold leading-[1.05] text-[40px] sm:text-[56px] mt-3">
              {servicesHero.title}
            </h1>
            <p className="text-white/75 text-[17px] mt-5 max-w-2xl leading-relaxed">
              {servicesHero.text}
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <CircleArrowLink to="/repair-estimate" variant="white">
                Book a repair slot
              </CircleArrowLink>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Cards */}
      <section className="py-20 lg:py-28">
        <div className="tnf-container">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {services.map((s, i) => (
              <Reveal key={s.slug} delay={i * 90} className="h-full">
                <ServiceCard service={s} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <WhyChooseUs />
      <LocationCTA />
    </>
  );
};

export default Services;
